// echartsOptions详情  固定参数
import dayjs from 'dayjs';

export const echartsOptions = {
  title: {
    text: 'CPU利用率(%)',
    left: '1%',
    top: 6,
    textStyle: {
      fontWeight: '600',
      fontSize: '12',
    },
  },
  tooltip: {
    trigger: 'axis',
  },
  label: {
    formatter: value => dayjs(Number(value.value)).format('YYYY-MM-DD HH:mm:ss'),
    align: 'right',
  },
  grid: {
    top: '14%',
    left: '7%',
    right: '9%',
    bottom: '20%',
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    axisLabel: {
      show: true,
    },
  },
  yAxis: {
    type: 'value',
  },
  toolbox: {
    right: 10,
    feature: {
      saveAsImage: {},
    },
  },
  graphic: [
    {
      type: 'text',
      left: 10,
      bottom: 21,
      style: {
        width: 14,
        height: 14,
        backgroundColor: '#409eff',
      },
    },
    {
      type: 'group',
      left: 30,
      bottom: 20,
      children: [
        {
          type: 'text',
          style: {
            fill: '#333',
            text: '暂无数据',
            font: '14px Microsoft YaHei',
          },
        },
      ],
    },
  ],
  series: {
    name: 'CPU利用率(%)',
    type: 'line',
    stack: 'Total',
    showSymbol: false,
    data: [],
    lineStyle: {
      color: '#409eff',
      width: 0.6,
    },
  },
};

// 时间快捷选项
export const dateShortcuts = [
  {
    text: '5分钟',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 300 * 1000);
      picker.$emit('pick', [start, end]);
    },
  },
  {
    text: '30分钟',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 1800 * 1000);
      picker.$emit('pick', [start, end]);
    },
  },
  {
    text: '1小时',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000);
      picker.$emit('pick', [start, end]);
    },
  },
  {
    text: '12小时',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 12);
      picker.$emit('pick', [start, end]);
    },
  },
  {
    text: '24小时',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24);
      picker.$emit('pick', [start, end]);
    },
  },
  {
    text: '7天',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit('pick', [start, end]);
    },
  },
  {
    text: '30天',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      picker.$emit('pick', [start, end]);
    },
  },
];

export const myLineChartList = [
  // cpu 监控
  [
    {
      loading: false,
      name: 'CPU利用率(%)',
      dom: null,
      key: 'CpuUsage',
      leftDistance: '102',
      value: 'CPU利用率是通过服务器内部监控组件采集上报，数据更加精准',
    },
    {
      loading: false,
      name: '基础CPU使用率(%)',
      dom: null,
      key: 'BaseCpuUsage',
      leftDistance: '130',
      value: '基础CPU使用率通过宿主机采集上报，无须安装监控组件即可查看数据，子机高负载情况下仍可持续采集上报数据',
    },
    {
      loading: false,
      name: 'CPU一分钟平均负载',
      dom: null,
      key: 'CpuLoadavg',
      leftDistance: '130',
      value: '1分钟内CPU平均负载，取第一列数据（windows操作系统无此指标），依赖监控组件安装采集',
    },
    {
      loading: false,
      name: 'CPU五分钟平均负载',
      dom: null,
      key: 'Cpuloadavg5m',
      leftDistance: '130',
      value: '5分钟内CPU平均负载，取第一列数据（windows操作系统无此指标），依赖监控组件安装采集',
    },
    {
      loading: false,
      name: 'CPU十五分钟平均负载',
      dom: null,
      key: 'Cpuloadavg15m',
      leftDistance: '144',
      value: '15分钟内CPU平均负载，取第一列数据（windows操作系统无此指标），依赖监控组件安装采集',
    },
  ],
  // 内存 监控
  [
    {
      loading: false,
      name: '内存利用率(%)',
      dom: null,
      key: 'MemUsage',
      leftDistance: '102',
      value: '用户实际使用的内存量与总内存量之比，不包括缓冲区与系统缓存占用的内存',
    },
    {
      loading: false,
      name: '内存使用量(MB)',
      dom: null,
      key: 'MemUsed',
      leftDistance: '110',
      value: '使用的内存量，不包括系统缓存和缓存区占用内存，依赖监控组件安装采集',
    },
  ],
  // 磁盘监控
  [
    {
      loading: false,
      name: '磁盘利用率(%)',
      dom: null,
      key: 'CvmDiskUsage',
      leftDistance: '102',
      value: '磁盘利用率',
    },
  ],
  // 网络监控
  [
    {
      loading: false,
      name: '内网入包量(个/s)',
      dom: null,
      key: 'LanInpkg',
      leftDistance: '112',
      value: '内网网卡的平均每秒入包量',
    },
    {
      loading: false,
      name: '内网出包量(个/s)',
      dom: null,
      key: 'LanOutpkg',
      leftDistance: '112',
      value: '内网网卡的平均每秒出包量',
    },
    {
      loading: false,
      name: 'TCP连接数(个)',
      dom: null,
      key: 'TcpCurrEstab',
      leftDistance: '102',
      value: '处于 ESTABLISHED 状态的 TCP 连接数量，依赖监控组件安装采集',
    },
    {
      loading: false,
      name: '内网入带宽(Mbps)',
      dom: null,
      key: 'LanIntraffic',
      leftDistance: '122',
      value: '内网网卡的平均每秒入流量',
    },
    {
      loading: false,
      name: '内网出带宽(Mbps)',
      dom: null,
      key: 'LanOuttraffic',
      leftDistance: '122',
      value: '内网网卡的平均每秒出流量',
    },
    // {
    //   loading: false,
    //   name: '子机utc时间和ntp时间差值(s)',
    //   dom: null,
    //   key: 'TimeOffset',
    //   leftDistance: '184',
    //   value: '子机utc时间和ntp时间差值',
    // },
    {
      loading: false,
      name: '外网入包量(个/s)',
      dom: null,
      key: 'WanInpkg',
      leftDistance: '112',
      value: '外网平均每秒入包量',
    },
    {
      loading: false,
      name: '外网出流量(MB)',
      dom: null,
      key: 'AccOuttraffic',
      leftDistance: '112',
      value: '外网网卡的平均每秒出流量',
    },
    {
      loading: false,
      name: '外网出包量(个/s)',
      dom: null,
      key: 'WanOutpkg',
      leftDistance: '112',
      value: '外网平均每秒出包量',
    },
    // {
    //   loading: false,
    //   name: '外网出带宽使用率(%)',
    //   dom: null,
    //   key: 'WanOuttraffic',
    //   leftDistance: '130',
    //   value: '外网出带宽使用率',
    // },
    {
      loading: false,
      name: '外网入带宽(Mbps)',
      dom: null,
      key: 'WanIntraffic',
      leftDistance: '126',
      value: '外网平均每秒入流量',
    },
    {
      loading: false,
      name: '外网出带宽(Mbps)',
      dom: null,
      key: 'WanOuttraffic',
      leftDistance: '126',
      value: '外网平均每秒出流量，最小粒度数据为10秒总流量/10秒 计算得出',
    },
  ],
];
